//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** The type of field to be displayed in the UI. */
export const ThemeFieldType = {
    /**
     * A CSS variable with a text input that will output the literal value
     * without any formatting.
     */
    Literal: 0,

    /** A CSS variable with a color input. */
    Color: 1,

    /** A CSS variable with an image input. */
    Image: 2,

    /**
     * A CSS variable with a text input. The value will be enclosed in
     * quotes and escaped.
     */
    Text: 3,

    /** A CSS variable with a file input. */
    File: 4,

    /**
     * A field that will include one of two custom CSS content templates.
     * The CSS variable will contain the text 'on' or 'off'.
     */
    Switch: 5,

    /** A heading above other fields. */
    Heading: 100,

    /** A spacer between fields. */
    Spacer: 101,

    /** A panel that wraps other fields. */
    Panel: 102
} as const;

/** The type of field to be displayed in the UI. */
export const ThemeFieldTypeDescription: Record<number, string> = {
    0: "Literal",

    1: "Color",

    2: "Image",

    3: "Text",

    4: "File",

    5: "Switch",

    100: "Heading",

    101: "Spacer",

    102: "Panel"
};

/** The type of field to be displayed in the UI. */
export type ThemeFieldType = typeof ThemeFieldType[keyof typeof ThemeFieldType];
